import { apiSlice } from "./apiSlice";

export const adminSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        //=============Users=======================
        getUsers: builder.query({
            query: params => ({
                url: '/admin/user',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        userUpdate: builder.mutation({
            query: ( {id, payload }) => ({
                url: `/admin/user/${id}`,
                method: 'PUT',
                body: {...payload}
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),

        getUserById: builder.query({
            query: (id) => ({
                url: `/admin/user/${id}`,
                method: 'GET',
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //==============Orders=====================
        getOrders: builder.query({
            query: (params) => ({
                url: '/admin/order',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getOrderById: builder.query({
            query: (id) => ({
                url: `/admin/order/${id}`,
                method: 'GET',
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //===========Service points CRUD================
        getServicePointsFromQoyod: builder.query({
            query: () => ({
                url: '/admin/quode/service-point',
                method: 'GET'
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getServicePoints: builder.query({
            query: (params) => ({
                url: '/admin/service-point',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getServicePointById: builder.query({
            query: ({ id, params }) => ({
                url: `/admin/service-point/${id}`,
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        createServicePoint: builder.mutation({
            query: (payload) => ({
                url: `/admin/service-point`,
                method: 'POST',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        updateServicePoint: builder.mutation({
            query: ({ id, payload }) => ({
                url: `/admin/service-point/${id}`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        deleteServicePoint: builder.mutation({
            query: (id) => ({
                url: `/admin/service-point/${id}`,
                method: 'DELETE'
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //================Slider CRUD===================
        getSliderImages: builder.query({
            query: (params) => ({
                url: '/admin/slider',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        createSliderImage: builder.mutation({
            query: (payload) => ({
                url: `/admin/slider`,
                method: 'POST',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        deleteSliderImage: builder.mutation({
            query: (id) => ({
                url: `/admin/slider/${id}`,
                method: 'DELETE'
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //================Frequently Asked Questions CRUD===================
        getFrequentlyAskedQuestions: builder.query({
            query: (params) => ({
                url: '/admin/faq',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        createFrequentlyAskedQuestion: builder.mutation({
            query: (payload) => ({
                url: `/admin/faq`,
                method: 'POST',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        updateFrequentlyAskedQuestion: builder.mutation({
            query: ({ id, payload }) => ({
                url: `/admin/faq/${id}`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        deleteFrequentlyAskedQuestion: builder.mutation({
            query: (id) => ({
                url: `/admin/faq/${id}`,
                method: 'DELETE'
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //================CRUD Notification===================
        getNotifications: builder.query({
            query: (params) => ({
                url: '/admin/notification',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        createNotification: builder.mutation({
            query: (payload) => ({
                url: `/admin/notification`,
                method: 'POST',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //================CRUD Promos===================
        getPromos: builder.query({
            query: (params) => ({
                url: '/admin/promo-code',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        createPromo: builder.mutation({
            query: (payload) => ({
                url: `/admin/promo-code`,
                method: 'POST',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        deletePromo: builder.mutation({
            query: (id) => ({
                url: `/admin/promo-code/${id}`,
                method: 'DELETE',
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //==============Subscribers=======================
        getSubscribers: builder.query({
            query: (params) => ({
                url: '/admin/email',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //==============Settings=======================
        getSettings: builder.query({
            query: () => ({
                url: '/admin/setting',
                method: 'GET',
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        updateSettings: builder.mutation({
            query: (payload) => ({
                url: `/admin/setting`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //================Driver CRUD===================
        getDrivers: builder.query({
            query: (params) => ({
                url: '/admin/driver',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        createDriver: builder.mutation({
            query: (payload) => ({
                url: `/admin/driver`,
                method: 'POST',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        updateDriver: builder.mutation({
            query: ({ id, payload }) => ({
                url: `/admin/driver/${id}`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        deleteDriver: builder.mutation({
            query: (id) => ({
                url: `/admin/driver/${id}`,
                method: 'DELETE'
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //================Employee CRUD===================
        getEmployees: builder.query({
            query: (params) => ({
                url: '/admin/lab-employee',
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        createEmployee: builder.mutation({
            query: (payload) => ({
                url: `/admin/lab-employee`,
                method: 'POST',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        updateEmployee: builder.mutation({
            query: ({ id, payload }) => ({
                url: `/admin/lab-employee/${id}`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        deleteEmployee: builder.mutation({
            query: (id) => ({
                url: `/admin/lab-employee/${id}`,
                method: 'DELETE'
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
    })
})

export const {
    //=============Users==================
    useGetUsersQuery,
    useGetSubscribersQuery,
    useGetUserByIdQuery,
    useUserUpdateMutation,
    //==============Service point==============
    useGetServicePointsQuery,
    useGetServicePointByIdQuery,
    useCreateServicePointMutation,
    useUpdateServicePointMutation,
    useDeleteServicePointMutation,
    useLazyGetServicePointsFromQoyodQuery,
    //=============Sliders==============
    useGetSliderImagesQuery,
    useCreateSliderImageMutation,
    useDeleteSliderImageMutation,
    //============Ask and answer===========
    useGetFrequentlyAskedQuestionsQuery,
    useCreateFrequentlyAskedQuestionMutation,
    useUpdateFrequentlyAskedQuestionMutation,
    useDeleteFrequentlyAskedQuestionMutation,
    //=============Notifications=========
    useGetNotificationsQuery,
    useCreateNotificationMutation,
    //=============Orders===========
    useGetOrderByIdQuery,
    useGetOrdersQuery,
    //============Promos============
    useGetPromosQuery,
    useCreatePromoMutation,
    useDeletePromoMutation,
    //===========Settings=========
    useGetSettingsQuery,
    useUpdateSettingsMutation,
    //===========Drivers=======
    useGetDriversQuery,
    useCreateDriverMutation,
    useUpdateDriverMutation,
    useDeleteDriverMutation,
    //===========Employees=======
    useGetEmployeesQuery,
    useCreateEmployeeMutation,
    useUpdateEmployeeMutation,
    useDeleteEmployeeMutation,
} = adminSlice